import { EmployeeDetail } from "../types/api/employees/EmployeeDetail";
import { Nullable } from "../types/custom/Nullable";

export const getPersonNameFirst = (person: Nullable<EmployeeDetail>) => {
    if (person) {
        return person.prefersNickName && person.nameNick ? person.nameNick : person.nameFirst;
    }
    return null;
};

export const getPersonNameFirstLast = (person: Nullable<EmployeeDetail>) => {
    if (person) {
        return person.prefersNickName && person.nameNick
            ? person.nameNick + ' ' + person.nameLast
            : person.nameFirst + ' ' + person.nameLast;
    }
    return null;
};